import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton} from '../../../../../../libs/shared/ui/src/components/utility/skeleton';
import {SynopsisHeader} from './synopsisHeader';
import {StyledSynopsisContentDiv} from './synopsisViewer';

const StyledTimelineDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 20px;
    border: 1px solid ${(p) => p.theme.message.readCommentBackground};
  }
`;

interface SynopsisSkeletonProps {
  onRequestClose: () => void;
  isPinnedCommentsOnly?: boolean;
}

export const SynopsisSkeleton: FC<SynopsisSkeletonProps> = ({onRequestClose, isPinnedCommentsOnly}) => (
  <>
    <SynopsisHeader onRequestClose={onRequestClose} isPinnedCommentsOnly={isPinnedCommentsOnly} />
    <StyledSynopsisContentDiv>
      <Skeleton width="100%" height="60px" />
      <StyledTimelineDiv>
        <Skeleton width="100%" height="68px" />
        <Skeleton width="100%" height="68px" />
        <Skeleton width="100%" height="30px" />
        <Skeleton width="100%" height="30px" />
      </StyledTimelineDiv>
    </StyledSynopsisContentDiv>
  </>
);
